import React from "react";

export default (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
		<title>file-picture</title>
		<path d="M26 28h-20v-4l6-10 8.219 10 5.781-4v8zM26 15c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zM28.681 7.159c-.694-.947-1.662-2.053-2.724-3.116s-2.169-2.03-3.116-2.724c-1.612-1.182-2.393-1.319-2.841-1.319h-15.5c-1.378 0-2.5 1.121-2.5 2.5v27c0 1.378 1.122 2.5 2.5 2.5h23c1.378 0 2.5-1.122 2.5-2.5v-19.5c0-.448-.137-1.23-1.319-2.841zm-4.138-1.702c.959.959 1.712 1.825 2.268 2.543h-4.811v-4.811c.718.556 1.584 1.309 2.543 2.268zm3.457 24.043c0 .271-.229.5-.5.5h-23c-.271 0-.5-.229-.5-.5v-27c0-.271.229-.5.5-.5h15.5v7c0 .552.448 1 1 1h7v19.5z" />
	</svg>
);



// WEBPACK FOOTER //
// ./src/utils/icons/filePicture.js